var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatSettings = function SvgChatSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentColor",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.23 6a1.54 1.54 0 1 0 0 3.08 1.54 1.54 0 0 0 0-3.08m-7.7 4.62a1.54 1.54 0 1 0 0 3.07 1.54 1.54 0 0 0 0-3.07m15.4 0a1.54 1.54 0 1 0 0 3.07 1.54 1.54 0 0 0 0-3.07m-7.7.76c-1.58 0-2.24 1.05-2.24 2.3 0 .43.2.85.2.85-.08.05-.21.2-.18.46.06.5.27.62.4.63.05.46.6 1.1.76 1.2v.73c-.37 1.15-2.79.9-2.79 3.07h7.7c0-2.18-2.42-1.92-2.8-3.07v-.74c.18-.08.72-.73.77-1.19.13-.01.34-.14.4-.63.03-.26-.1-.4-.18-.46 0 0 .2-.38.2-.85 0-.93-.36-1.72-1.12-1.72 0 0-.26-.58-1.12-.58m-7.7 6.93a1.54 1.54 0 1 0 0 3.07 1.54 1.54 0 0 0 0-3.07m15.4 0a1.54 1.54 0 1 0 0 3.07 1.54 1.54 0 0 0 0-3.07m-7.7 4.61a1.54 1.54 0 1 0 0 3.08 1.54 1.54 0 0 0 0-3.08"
  })));
};
export default SvgChatSettings;